import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, TextField, Tooltip, Container, CircularProgress, Typography, InputAdornment, Box, AppBar, Toolbar, Table, Modal, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import base64 from 'base64-js';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const State = () => {
  const [page, setPage] = useState(1);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [states, setStates] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [authorization, setAuthorization] = useState([]);
  const [canDelete, setCanDelete] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [canAdd, setCanAdd] = useState(true);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [selectedState, setselectedState] = useState({ stateId: null, stateName: '' });
  const [showModal, setShowModal] = useState(false);

  let navigate = useNavigate();
  const { encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);

  const handleClick = () => {
    navigate('/addstate');
    console.log('ADD NEW STATE');
  };


  const handleDelete = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/State/Id?StateId=${selectedState.stateId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
        }
      );
      if (response.ok) {
        // Handle success, e.g., refresh the data
        setShowModal(false);
        setLoadingBarProgress(100);
        fetchStateData();
        setSnackbarMessage('State deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success");
      } else {
        setLoadingBarProgress(0);
        console.error('Delete failed');
        // alert('Failed to delete state');
        setSnackbarMessage('Failed to delete state');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error"); 
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error"); 
    }
  };


  const handleClose = () => {
    setShowModal(false);
  };

  const handleEdit = (stateId) => {
    navigate(`/editstate/${stateId}`);
  };

  const fetchStateData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const response = await fetch(`${apiUrl}/State/GetState`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({}),
      });

      if (response.ok) {
        setLoadingBarProgress(100);
        const stateData = await response.json();
        setStates(stateData);
        setFilteredData(stateData); // Set filtered data initially
      } else {
        setLoadingBarProgress(0);
        console.error('Failed to fetch state data');
      }
    } catch (error) {
      console.error('API request error:', error);
    }
  };

  const handleShow = (stateId, stateName) => {
    setselectedState({ stateId, stateName });
    setShowModal(true);
  };

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        const authorizationData = responseData[0];
        setCanDelete(authorizationData.uDelete === 1);
        setCanEdit(authorizationData.uModify === 1);
        setCanAdd(authorizationData.uWrite === 1);
      } else {
        console.error('Country name incorrect');
        // alert('Invalid country name');
        setSnackbarMessage('Invalid country name');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("warrning"); 
      }
    } catch (error) {
      console.error('API request error:', error);
      // alert('An error occurred. Please try again later.');
      setSnackbarMessage('An error occurred. Please try again later.');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error"); 
    }
  };


  useEffect(() => {
    fetchStateData();
    Authorizer();
  }, []);


  useEffect(() => {
    setFilteredData(
      states.filter((state) =>
        state.stateName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, states]);

  const handleSearch = () => {
    setFilteredData(
      states.filter((state) =>
        state.stateName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  const paginatedData = filteredData.slice(
  (page - 1) * rowsPerPage,
  page * rowsPerPage
);


  const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(1); // reset to page 1
};



  return (
    <Container>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: "bold" }}>
            State
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
        <Container mt={5}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}> {/* Align vertically */}
            <TextField
              variant="outlined"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "300px" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
                style: { padding: '0px 8px' },
              }}
              sx={{
                width: 300,
                backgroundColor: '#f9f9f9',
              }}
            />
            <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow><span>
              <Button
                variant="contained"
                className="mb-2 my-2"
                onClick={handleClick}
                style={{
                  width: "120px",
                  height: "50px",
                  padding: "10px 0",
                  fontWeight: 'bold'
                }}
                disabled={!canAdd}

              >
                ADD STATE
              </Button></span></Tooltip>
          </div>
        </Container>


        <TableContainer component={Paper} mt={8}>
          <Table
            sx={{
              minWidth: 650,
              border: '1px solid #ccc',
              '& .MuiTableCell-root': {
                borderRight: '1px solid #ccc', // vertical line
                fontSize: '1rem', // increased font size
              },
              '& .MuiTableHead-root .MuiTableCell-root': {
                fontWeight: 'bold',
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid #ccc', fontWeight: 'bold' }}>
                  Country Name
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid #ccc', fontWeight: 'bold' }}>
                  State
                </TableCell>
                <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
          <TableBody>
  {loadingBarProgress > 0 && loadingBarProgress < 100 ? (
    <TableRow>
      <TableCell colSpan={3} align="center">
        <CircularProgress />
      </TableCell>
    </TableRow>
  ) : paginatedData.length > 0 ? (
    paginatedData.map((state, index) => (
      <TableRow key={index} sx={{ borderTop: '1px solid #ccc' }}>
        <TableCell sx={{ borderRight: '1px solid #ccc' }}>
          {state.countryName}
        </TableCell>
        <TableCell sx={{ borderRight: '1px solid #ccc' }}>
          {state.stateName}
        </TableCell>
        <TableCell sx={{ textAlign: 'center' }}>
          <Tooltip title={canEdit ? '' : 'You are not authorized to edit'} arrow>
            <span>
              <Button
                variant="contained"
                color="warning"
                onClick={() => handleEdit(state.stateId)}
                disabled={!canEdit}
                startIcon={<EditIcon />}
                sx={{ marginRight: 1 }}
              >
                Edit
              </Button>
            </span>
          </Tooltip>
          <Tooltip title={canDelete ? '' : 'You are not authorized to delete'} arrow>
            <span>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleShow(state.stateId, state.stateName)}
                disabled={!canDelete}
                startIcon={<DeleteIcon />}
              >
                Delete
              </Button>
            </span>
          </Tooltip>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={3} align="center">
        No States Found
      </TableCell>
    </TableRow>
  )}
</TableBody>

          </Table>

          <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                overflow: 'hidden',
              }}
            >
              {/* Header */}
              <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
                <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
                  Delete Confirmation ⚠️
                </Typography>
              </Box>

              {/* Content */}
              <Box sx={{ padding: '20px' }}>
                <Typography id="delete-modal-description" sx={{ mb: 2 }}>
                  Are you sure you want to delete <strong>{selectedState?.stateName}</strong>?
                </Typography>

                {/* Buttons */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDelete(handleDelete)}
                  >
                    Yes, Delete
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        </TableContainer>

        {filteredData.length > 0 && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
    <TextField
      select
      label="Rows per page"
      value={rowsPerPage}
      onChange={handleChangeRowsPerPage}
      sx={{ width: 150 }}
      SelectProps={{
        native: true,
      }}
    >
      {rowsPerPageOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </TextField>

    <Box>
      <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
        Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
      </Typography>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page - 1)}
        disabled={page === 1}
        sx={{ mr: 1 }}
      >
        Prev
      </Button>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page + 1)}
        disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
      >
        Next
      </Button>
    </Box>
  </Box>
)}

      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default State;
// {selectedState?.stateName}
